function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getProductTypesByCategoryRegex } from '../utils';
var base = '';
var slugs = {
  products: 'productos',
  managementCompanies: 'gestoras',
  categories: 'categoria',
  category: 'categorias',
  comparison: 'comparador'
};
var iicRegex = getProductTypesByCategoryRegex('iic');
var genericRegex = getProductTypesByCategoryRegex('content');
var iicRoutes = {
  PlansHome: "".concat(base, "/:typeSlug(planes-pensiones)"),
  FundsHome: "".concat(base, "/:typeSlug(").concat(iicRegex, ")"),
  ETFsHome: '/:typeSlug(etfs)',
  FundsList: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/listado"),
  FundsComparison: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/").concat(slugs.comparison),
  FundsCategories: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/").concat(slugs.categories),
  FundsCategoriesTab: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/").concat(slugs.categories, "/:tab"),
  FundsCategory: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/").concat(slugs.category, "/:id-:alias([^/]+)"),
  FundsManagementCompanies: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/").concat(slugs.managementCompanies),
  FundsManagementCompany: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/").concat(slugs.managementCompanies, "/:id-:alias([^/]+)"),
  FundSheet: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/:isin-:alias([^/]+)"),
  FundSheetById: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/:id([a-fA-F0-9]{8})"),
  FundReviews: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/:isin-:productSlug/reviews"),
  FundQuestions: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/:isin-:productSlug/preguntas"),
  FundReview: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/:isin-:alias/reviews/:idReview([a-fA-F0-9]{32})"),
  FundWriteReview: "".concat(base, "/:typeSlug(").concat(iicRegex, ")/:isin-:alias/reviews/nueva-review")
};
var contentRoutes = {
  DigitalHome: '/:typeSlug(activos-digitales)',
  AlternativesHome: '/:typeSlug(alternativos)',
  PersonalHome: '/:typeSlug(finanzas-personales)',
  ProductsHome: "/:productTypeSlug(".concat(genericRegex, ")"),
  ProductSheet: "/:productTypeSlug(".concat(genericRegex, ")/:productSlug"),
  ProductCheckout: "/:productTypeSlug(".concat(genericRegex, ")/:productSlug/comprar"),
  ProductsComparison: "/:productTypeSlug(".concat(genericRegex, ")/comparador"),
  ProductReviews: "/:productTypeSlug(".concat(genericRegex, ")/:productSlug/reviews"),
  ProductQuestions: "/:productTypeSlug(".concat(genericRegex, ")/:productSlug/preguntas"),
  ProductReview: "/:typeSlug(".concat(genericRegex, ")/:alias/reviews/:idReview([a-fA-F0-9]{32})"),
  ProductWriteReview: "/:typeSlug(".concat(genericRegex, ")/:alias/reviews/nueva-review"),
  WriteQuestion: "/preguntas/nueva-pregunta"
};
var banksRoutes = {
  BankArticle: '/bancos/:organization/articulos/:article',
  BankProducts: "/bancos/:organization/productos/:typeSlug(".concat("".concat(iicRegex, "|").concat(genericRegex), ")"),
  Bank: '/bancos/:organization',
  BankArticleList: '/bancos/:organization/analisis',
  Banks: '/bancos'
};
var storefrontsRoutes = {
  StorefrontsHome: '/invertir',
  Storefront: '/invertir/:tag',
  StorefrontProductsList: '/invertir/:tag/listado'
};
var topicsRoutes = {
  Topic: '/temas/:tag'
};
var userRoutes = {
  UserProfile: '/usuario/:alias'
};
var groupsRoutes = {
  GroupProfile: '/grupos/:profile'
};
var questionsRoutes = {
  Question: '/preguntas/:id/:alias'
};
var financialPlanRoutes = {
  FinancialPlan: '/tus-finanzas/plan-financiero',
  FinancialPlanObjective: '/tus-finanzas/plan-financiero/objetivos/:id',
  FinancialPlanFlow: '/tus-finanzas/plan-financiero/flujos/:id',
  FinancialPlanRealEstate: '/tus-finanzas/plan-financiero/inmuebles/:id',
  FinancialPlanInsurance: '/tus-finanzas/plan-financiero/seguros/:id'
};
export var routes = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, iicRoutes), contentRoutes), financialPlanRoutes), userRoutes), groupsRoutes), questionsRoutes), banksRoutes), storefrontsRoutes), topicsRoutes);